import { useId } from 'react'
import { Switch } from 'antd'
import Textarea from '@UI/Textarea'
import TooltipWrapper from '@UI/New/TooltipWrapper/TooltipWrapper'
import { InfoCircleOutlined } from '@ant-design/icons'
import s from './index.module.css'

const PaymentCommentField = ({ field, label = 'Комментарий', tooltip = '', disabled = false }) => {
  const id = useId()

  return (
    <div className={s.field}>
      <div className={s.labelRow}>
        <label htmlFor={id}>{label}{!field.leaveEmpty && ' *'}</label>
        {tooltip && (
          <TooltipWrapper title={tooltip}>
            <InfoCircleOutlined />
          </TooltipWrapper>
        )}
      </div>
      <Textarea
        id={id}
        inputRef={field.inputRef}
        className={s.textarea}
        value={field.comment}
        onChange={(event) => field.setComment(event.target.value)}
        disabled={disabled || field.leaveEmpty}
        placeholder="Введите комментарий"
        error={field.error}
        aria-required={!field.leaveEmpty}
        aria-invalid={field.error}
        aria-describedby={field.error ? `${id}-error` : undefined}
        maxAutoHeight={180}
      />
      {field.error && (
        <span id={`${id}-error`} className={s.error} role="alert">
          Введите комментарий или включите «Оставить комментарий пустым».
        </span>
      )}
      <div className={s.switchRow}>
        <Switch
          id={`${id}-empty`}
          size="small"
          className={s.switch}
          checked={field.leaveEmpty}
          onChange={field.setLeaveEmpty}
          disabled={disabled}
          aria-labelledby={`${id}-empty-label`}
        />
        <label id={`${id}-empty-label`} htmlFor={`${id}-empty`}>
          Оставить комментарий пустым
        </label>
      </div>
    </div>
  )
}

export default PaymentCommentField
